'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventListController = function () {

  /*@ngInject*/
  function EventListController(Events, list, $sce, marked, $state) {
    _classCallCheck(this, EventListController);

    this.errors = {
      other: undefined
    };
    this.message = '';
    this.submitted = false;
    this.year = new Date().getFullYear();
    this.yearsToList = 2;
    this.years = [];

    console.log(list);
    this.list = list;
    this._$sce = $sce;
    this._$state = $state;
    this._$marked = marked;
    this._Events = Events;
  }

  _createClass(EventListController, [{
    key: 'updateMarkdown',
    value: function updateMarkdown(input) {
      var renderedHTML = '';
      if (input) {
        renderedHTML = this._$sce.trustAsHtml(this._$marked(input));
      }
      return renderedHTML;
    }
  }, {
    key: 'deleteEvent',
    value: function deleteEvent(event) {
      var _this = this;

      this._Events.delete(event._id).then(function (res) {
        console.log('Result', res);
        _this.list.splice(_this.list.indexOf(event), 1);
      }).catch(function (err) {
        console.log('Error', err);
      });
    }
  }]);

  return EventListController;
}();

exports.default = EventListController;


// WEBPACK FOOTER //
// ./client/app/events/list/list.controller.js